import { DateRangePicker, DateRangePickerProps, LocalizationProvider } from '@material-ui/pickers';
import DateFnsAdapter from '@material-ui/pickers/adapter/date-fns';
import { DateRange as MuiDateRange } from '@material-ui/pickers/DateRangePicker/RangeTypes';
import { MuiTextFieldProps } from '@material-ui/pickers/_shared/PureDateInput';
import locale from 'date-fns/locale/pt-BR';
import React from 'react';
import RenderInput from './Input';

export type DateRange<TDate = unknown> = MuiDateRange<TDate>;

type IProps = Omit<DateRangePickerProps, 'renderInput'> & {
};

function DateRangeField({ onChange, value, ...props }: IProps) {
  const handleChange = (date: MuiDateRange) => {
    onChange(date);
  };

  const handleClear = () => {
    handleChange([null, null]);
  };

  const renderInput = (startProps: MuiTextFieldProps, endProps: MuiTextFieldProps,) => {
    return RenderInput(startProps, endProps, handleClear,);
  };

  return (
    <LocalizationProvider dateAdapter={DateFnsAdapter} locale={locale}>
      <DateRangePicker {...props} value={value} onChange={handleChange} renderInput={renderInput} allowSameDateSelection={true}/>
    </LocalizationProvider>
  );
}

export default DateRangeField;